import { PailOffIcon } from './PailOffIcon';

/**
 * author: Michael Irigoyen
 * id 2F1D4972-0025-4EB4-ADFC-2ACBEF34C7EA
 * name pail-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-off.svg
 * tags
 */
export const BucketOffIcon = PailOffIcon;
export default BucketOffIcon